import { Injectable } from '@angular/core';
import { NavigationExtras, Params, Data } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { RouterSelectors } from './router.selectors';
import { RouterActions } from './router.actions';
import * as fromCore from './core.reducer';
import { CoreStoreService } from './core-store.service';

@Injectable({
    providedIn: 'root',
})
export class RouterStoreService extends CoreStoreService {
    constructor(store: Store<fromCore.State>) {
        super(store);
    }

    navigate(path: any[], query?: object, extras?: NavigationExtras) {
        this.store.dispatch(RouterActions.go({ path, query, extras }));
    }

    selectQueryParams(): Observable<Params> {
        return this.select(RouterSelectors.selectQueryParams);
    }

    selectQueryParam(param: string): Observable<string> {
        return this.select(RouterSelectors.selectQueryParam(param));
    }

    selectRouteParams(): Observable<Params> {
        return this.select(RouterSelectors.selectRouteParams);
    }

    selectRouteParam(param: string): Observable<string> {
        return this.select(RouterSelectors.selectRouteParam(param));
    }

    selectRouteData(): Observable<Data> {
        return this.select(RouterSelectors.selectRouteData);
    }

    selectUrl(): Observable<string> {
        return this.select(RouterSelectors.selectUrl);
    }

}
